import { render, staticRenderFns } from "./BookingStatusChart.vue?vue&type=template&id=13c22258"
import script from "./BookingStatusChart.vue?vue&type=script&lang=js"
export * from "./BookingStatusChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports